import { buildSparklineGeometry } from './helpers'
import {
  SparklineSurface,
  SparklineSvg,
  SparklinePath,
  SparklineArea,
  Endpoint,
  EmptyBlock,
} from './styled'
import { PriceSparklineProps } from './types'

const DEFAULT_WIDTH = 480
const DEFAULT_HEIGHT = 96

/**
 * SVG-based sparkline for the price-history series. Walks each entry
 * with a non-null priceMonthly, scales them into the viewport, and
 * renders a filled-area + line + endpoint dot. Trend colour reflects
 * direction: green for drops, warmth-orange for rises, primary for flat.
 *
 * @param {PriceSparklineProps} props
 * @returns {JSX.Element}
 */
const PriceSparkline = ({
  entries,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
}: PriceSparklineProps): JSX.Element => {
  const geometry = buildSparklineGeometry(entries, width, height)

  if (geometry.hasData === false) {
    return <EmptyBlock>No price history yet.</EmptyBlock>
  }

  return (
    <SparklineSurface>
      <SparklineSvg
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
        role="img"
        aria-label="Price history sparkline"
      >
        <SparklineArea trend={geometry.trendDirection} d={geometry.areaData} />
        <SparklinePath trend={geometry.trendDirection} d={geometry.pathData} />
        <Endpoint
          trend={geometry.trendDirection}
          cx={geometry.endpointX}
          cy={geometry.endpointY}
          r="4"
        />
      </SparklineSvg>
    </SparklineSurface>
  )
}

export default PriceSparkline
